import React, { useState } from 'react';
import { Button } from '@/shared/ui/components/Button';
import { logger } from '@/shared/lib';

// Test component that can trigger different types of errors
export const ErrorBoundaryTest: React.FC = () => {
  const [shouldThrowError, setShouldThrowError] = useState(false);
  const [errorType, setErrorType] = useState<'render' | 'async'>('render');

  if (shouldThrowError && errorType === 'render') {
    throw new Error('Test render error from ErrorBoundaryTest component');
  }

  const handleAsyncError = async () => {
    try {
      // Simulate an API error
      throw new Error('Test async error');
    } catch (error) {
      logger.error('Async error (not caught by ErrorBoundary):', error);
    }
  };

  return (
    <div className="p-4 border border-gray-300 rounded">
      <h3 className="text-lg font-semibold mb-4">Error Boundary Test</h3>
      <div className="space-y-2">
        <div className="flex gap-2">
          <Button
            onClick={() => {
              setErrorType('render');
              setShouldThrowError(true);
            }}
            variant="danger"
            size="sm"
          >
            Trigger Render Error
          </Button>
          <Button
            onClick={handleAsyncError}
            variant="warning"
            size="sm"
          >
            Trigger Async Error
          </Button>
        </div>
        <p className="text-sm text-gray-600">
          • Render Error: Will be caught by ErrorBoundary<br/>
          • Async Error: Will not be caught by ErrorBoundary (check console)
        </p>
      </div>
    </div>
  );
};